import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';

import { CuadriculasComponent } from './cuadriculas.component';
import { HeaderModule } from '../header/header.module';
import { SharedModule } from 'src/app/shared/shared.module';
import { LoaderComponent } from "../../../../projects/movisat-common-gui/src/lib/components/loader/loader.component";
import { WindowComponent } from "../../../../projects/movisat-common-gui/src/lib/components/window/window.component";
import { EditarCuadriculaComponent } from './editar-cuadricula/editar-cuadricula.component';

@NgModule({
  declarations: [
    CuadriculasComponent, EditarCuadriculaComponent
  ],
  imports: [
    FormsModule,
    CommonModule,
    SharedModule,
    ReactiveFormsModule,
    HeaderModule,
    LoaderComponent,
    WindowComponent
],
  exports: [
    CuadriculasComponent
  ]
})
export class CuadriculasModule { }
